module.exports = __webpack_public_path__ + "static/media/report_1t.bc00dd87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/report_1t.jpg
// module id = 411
// module chunks = 0